import { PageHeader } from 'teacher-ui-client/components/page-header'
import { LinkTo } from '@ember/routing'
import { t, type IntlService } from 'ember-intl'
import RouteTemplate from 'ember-route-template'
import Component from '@glimmer/component'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'
import { service } from '@ember/service'
import RenewTrial from 'teacher-ui-client/components/page/renew-trial'

export class SubscriptionTypeAccessExpiredPage extends Component<unknown> {
  @service subscriptionType!: SubscriptionTypeService

  @service intl!: IntlService

  get productName() {
    const productNames = {
      [SubscriptionType.Reading]: this.intl.t('products.re'),
      [SubscriptionType.Maths]: this.intl.t('products.ms'),
      [SubscriptionType.Writing]: this.intl.t('products.writing-legends'),
    }
    return productNames[this.subscriptionType.current] ?? ''
  }

  get showWritingLegendsRenewTrialPage() {
    return this.subscriptionType.current === SubscriptionType.Writing
  }

  <template>
    {{#if this.showWritingLegendsRenewTrialPage}}
      <RenewTrial />
    {{else}}
      <div class="grow">
        <PageHeader>
          <:title>
            <h1>
              {{t "pages.accessExpired.title"}}
            </h1>
          </:title>
        </PageHeader>

        <p class="mb-3 text-center">
          {{t "pages.accessExpired.explanation" product=this.productName}}
        </p>

        <p class="mb-3 text-center">
          {{t "pages.accessExpired.contactUs.pre"}}
          <LinkTo @route="subscription-type.contact-us" data-test-contact-us-link>
            {{t "pages.accessExpired.contactUs.link"}}
          </LinkTo>
        </p>
      </div>
    {{/if}}
  </template>
}

export default RouteTemplate(SubscriptionTypeAccessExpiredPage)
